const challengeConstants = {
  CHALLENGE_REQUEST: 'CHALLENGE_REQUEST',
  CHALLENGE_REQUEST_SUCCESS: 'CHALLENGE_REQUEST_SUCCESS',
  CHALLENGE_REQUEST_FAILURE: 'CHALLENGE_REQUEST_FAILURE',
  CHALLENGE_CLOSED: 'CHALLENGE_CLOSED',
  CHALLENGE_RESPONSE_CHANGED: 'CHALLENGE_RESPONSE_CHANGED',
  CHALLENGE_VALIDATE: 'CHALLENGE_VALIDATE',
  CHALLENGE_VALIDATE_SUCCESS: 'CHALLENGE_VALIDATE_SUCCESS',
  CHALLENGE_VALIDATE_FAILURE: 'CHALLENGE_VALIDATE_FAILURE',
  CHALLENGE_REQUEST_SMS: 'CHALLENGE_REQUEST_SMS',
  CHALLENGE_REQUEST_SMS_SUCCESS: 'CHALLENGE_REQUEST_SMS_SUCCESS',
  CHALLENGE_REQUEST_SMS_FAILURE: 'CHALLENGE_REQUEST_SMS_FAILURE',
  CHALLENGE_VALIDATE_SMS_SUCCESS: 'CHALLENGE_VALIDATE_SMS_SUCCESS',
  CHALLENGE_RESPONSE_SMS_CHANGED: 'CHALLENGE_RESPONSE_SMS_CHANGED',
  CHALLENGE_INVALID: 'CHALLENGE_INVALID',
  CHALLENGE_ERROR_MESSAGE_CHANGED: 'CHALLENGE_ERROR_MESSAGE_CHANGED'
};

export default challengeConstants;
